import { ChangeEvent, FC, PropsWithChildren, ReactNode } from 'react';
import {
  RadioProvider,
  RadioProviderProps,
  useRadioContext,
} from '@/components/functional/RadioInput/RadioContext.tsx';
import CheckboxInput, { CheckboxInputProps } from '@/components/functional/CheckboxInput/CheckboxInput.tsx';

function Group<T>({ children, ...props }: PropsWithChildren<RadioProviderProps<T>>) {
  return <RadioProvider {...props}>{children}</RadioProvider>;
}

type InputProps = Omit<CheckboxInputProps, 'type'> & {
  render?: (
    props: Pick<CheckboxInputProps, 'value' | 'onChange'> &
      Pick<ReturnType<typeof useRadioContext>, 'error'> & {
        checked: boolean;
      }
  ) => ReactNode;
};

const Input: FC<InputProps> = ({ label, wrapperClassName, value, color, render, ...rest }) => {
  const { value: globalValue, setValue, error, color: globalColor } = useRadioContext();

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const checked = value === globalValue && value !== undefined;

  return render ? (
    render({
      value,
      onChange,
      checked,
      error,
    })
  ) : (
    <CheckboxInput
      wrapperClassName={wrapperClassName}
      error={error}
      label={label}
      value={value}
      checked={checked}
      onChange={onChange}
      color={color ?? globalColor}
      {...rest}
      type="radio"
    />
  );
};

export default {
  Group,
  Input,
};
